import { crmApiInstance } from './client.js';

const api = crmApiInstance;

export const callAdminAPI = {
  /** GET /api/admin/call-logs */
  getLogs: (params = {}) => api.get('/admin/call-logs', { params }),

  /** GET /api/admin/queue */
  getQueue: (params = {}) => api.get('/admin/queue', { params }),

  /** POST /api/admin/queue — manually add a lead to a CRM user's queue */
  addToQueue: (data) => api.post('/admin/queue', data),

  /** GET /api/admin/crm-users */
  getCrmUsers: () => api.get('/admin/crm-users'),

  /** GET /api/leads?search=&limit= — for lead search in add-to-queue form */
  searchLeads: (params = {}) => api.get('/leads', { params }),

  /** POST /api/admin/queue/redistribute — redistribute an absent user's pending queue to others */
  redistribute: (data) => api.post('/admin/queue/redistribute', data),

  /** POST /api/admin/queue/run-populate — manually trigger the daily queue population cron */
  runPopulate: () => api.post('/admin/queue/run-populate'),

  /** GET /api/admin/daily-tracker?date=&user_id= */
  getDailyTracker: (params = {}) => api.get('/admin/daily-tracker', { params }),
};
